module.exports = __webpack_public_path__ + "static/media/nuc.13ac466e.webp";